import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  COUNTRY_ADMIN_USER_CREATE, COUNTRY_LIST_DROPDOWN, ROLE_LIST_DROPDOWN
} from "../../../routes/routes";
import { toast } from "react-toastify";
import { COUNTRY_ADMIN_USER_CREATED } from "../../../constant/constant";
import { ValidationMessage } from "../../../components/Utils";
import Select from "react-select";

const CountryAdminUserCreate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState();
  const [errors, setErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [countryOptions, setCountryOptions] = useState({});
  const [roleOptions, setRoleOptions] = useState({});
  const [type, setType] = useState("password");
  const [type1, setType1] = useState("password");


  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .post(COUNTRY_ADMIN_USER_CREATE, requestBody)
      .then((res) => {
        if (res.status === 201 && res.data.success) {
          toast.success(COUNTRY_ADMIN_USER_CREATED);
          navigate("/country-admin-users");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      }).finally(() => {
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch role data
        const roleResponse = await axios.get(ROLE_LIST_DROPDOWN);
        const fetchedRoleOptions = roleResponse.data.data;
        setRoleOptions(fetchedRoleOptions);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Country Admins</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/country-admin-users"}>
                    <span>Country Admin Users List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Create Country Admin User</span></li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/country-admin-users"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Create User</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">

                    <div className="col-6 mb-3">
                      <label htmlFor="country_id" className="form-label">
                        Country<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={countryOptions}
                        onChange={(selected) => setForm({ ...form, country_id: Number(selected.value) })}
                      />
                      <ValidationMessage error={errors} name="country_id" />
                    </div>

                    <div className="col-6 mb-3">
                      <label htmlFor="admin_role_id" className="form-label">
                        Admin Role<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={roleOptions}
                        onChange={(selected) => setForm({ ...form, admin_role_id: Number(selected.value) })}
                      />
                      <ValidationMessage error={errors} name="admin_role_id" />
                    </div>


                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="name"
                        >
                          Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="email"
                        >
                          Email<span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Email"
                          onChange={(e) =>
                            setForm({ ...form, email: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="email" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="mobile_number"
                        >
                          Mobile Number<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control hide-arrow"
                          id="mobile_number"
                          placeholder="Mobile No"
                          onChange={(e) =>
                            setForm({ ...form, mobile_number: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="mobile_number" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="password"
                        >
                          Password<span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type={type}
                            className="form-control"
                            id="password"
                            placeholder="***********"
                            onChange={(e) =>
                              setForm({ ...form, password: e.target.value })
                            }
                          />
                          {type === "password" ? (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType('text')}
                            >
                              <i className="bx bx-hide"></i>
                            </span>
                          ) : (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType('password')}
                            >
                              <i className="bx bx-show"></i>
                            </span>
                          )}
                        </div>
                        <ValidationMessage error={errors} name="password" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="confirm_password"
                        >
                          Confirm Password<span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type={type1}
                            className="form-control"
                            id="confirm_password"
                            placeholder="***********"
                            onChange={(e) =>
                              setForm({
                                ...form,
                                confirm_password: e.target.value,
                              })
                            }
                          />
                          {type1 === "password" ? (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType1('text')}
                            >
                              <i className="bx bx-hide"></i>
                            </span>
                          ) : (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType1('password')}
                            >
                              <i className="bx bx-show"></i>
                            </span>
                          )}
                        </div>
                        <ValidationMessage
                          error={errors}
                          name="confirm_password"
                        />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/country-admin-users"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        &nbsp; Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryAdminUserCreate;
